import { render } from "./BindingStep2View.vue?vue&type=template&id=1d073739&scoped=true"
import script from "./BindingStep2View.vue?vue&type=script&lang=js"
export * from "./BindingStep2View.vue?vue&type=script&lang=js"

import "./BindingStep2View.vue?vue&type=style&index=0&id=1d073739&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d073739"]])

export default __exports__